import {GROUP_TYPES, POLICE_CODES, SeasonRule} from '@guestapp/sdk';
import {COUNTRY_CODES} from 'utils/constants';
import {FORM_NAMES} from './constants';

const getSpainAge = (policeType?: string) => {
  if (policeType === POLICE_CODES.nationalPolice) {
    return 16;
  } else if (policeType === POLICE_CODES.nat) {
    return 14;
  } else {
    return null;
  }
};

const getAgeLimitByCountry = (countryCode: string, policeType?: string) => {
  return (
    {
      [COUNTRY_CODES.spain]: {ageLimit: getSpainAge(policeType)},
      [COUNTRY_CODES.uk]: {ageLimit: 16},
      [COUNTRY_CODES.greece]: {ageLimit: 14},
      [COUNTRY_CODES.sweden]: {ageLimit: 18},
    }[countryCode] || {ageLimit: null}
  );
};
type GetFieldsProps = {
  betweenRule?: SeasonRule | null;
  lessThanRule?: SeasonRule | null;
  moreThanRule?: SeasonRule | null;
};
function getFields({lessThanRule, betweenRule, moreThanRule}: GetFieldsProps) {
  const fields = {} as Record<FORM_NAMES, boolean>;
  const hasLessThanRange = Boolean(lessThanRule?.id);
  const hasBetweenRange = Boolean(betweenRule?.id);
  const hasMoreThanRange = Boolean(moreThanRule?.id);
  const hasAtLeastOneGroup = [
    hasLessThanRange,
    hasBetweenRange,
    hasMoreThanRange,
  ].includes(true);

  if (hasAtLeastOneGroup) {
    fields[FORM_NAMES.junior] = hasAtLeastOneGroup;

    const needToFillBetweenTwoGroups =
      hasLessThanRange &&
      hasMoreThanRange &&
      (moreThanRule?.up_to ?? 0) - (lessThanRule?.less_than ?? 0) > 1;

    const isThereOnlyLessThanGroup = hasLessThanRange && !hasMoreThanRange;

    fields[FORM_NAMES.middle] =
      hasBetweenRange || needToFillBetweenTwoGroups || isThereOnlyLessThanGroup;

    fields[FORM_NAMES.senior] = hasBetweenRange || hasMoreThanRange;
  }

  fields[FORM_NAMES.numberOfGuests] = !hasAtLeastOneGroup;

  return fields;
}

const getGroupType = (numberOfGuests: number, value?: GROUP_TYPES) => {
  if (!numberOfGuests) {
    return;
  }

  if (numberOfGuests > 1) {
    return value;
  }

  return GROUP_TYPES.single;
};

export {getAgeLimitByCountry, getFields, getGroupType};
